<template>
    <div :id="id">
        <slot />
    </div>
</template>

<script>
import fitty from 'fitty';

export default {
    name: 'AppFitText',
    props: {
        options: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        instance: null
    }),
    computed: {
        id() {
            return 'fitty-' + this._uid;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.createInstance();
        });
    },
    methods: {
        createInstance() {
            this.instance = fitty('#' + this.id, this.getOptions());
        },
        getOptions() {
            return {
                minSize: 18,
                maxSize: 70,
                ...this.options
            };
        }
    }
};
</script>
